import React from 'react';
//import translation function for language translation
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const MaterialCalendarBreadCrump = ({selectedKit}) => {
  const { t } = useTranslation(); //for translation
  return (
    <nav aria-label="breadcrumb">
      <ul className="breadcrumb">
        <li className="breadcrumb-item">
          <Link to="dashboard.html" className="text-secondary">
            {t('Funbrain')}
          </Link>
        </li>
        <li className="breadcrumb-item text-gray-600" aria-current="page">
          {t('Material Kit Availability')}
        </li>
        <li className="d-flex align-items-center gap-3 ms-5">
            <p className="mb-0">KT : {t("Kit total per day")}</p>
            <p className="mb-0">KA : {t("Kit assigned in reserves")}</p>
            
        </li>
      </ul>
    </nav>
  );
};

export default MaterialCalendarBreadCrump;
